import { AssociatedMediasResource } from "./associated-medias"
import { ManagementDataResource } from "./management-data"
import { TranslatedString } from "./translated-string"

export const BUSINESS_RESOURCE_FIELDS = [
    "id",
    "managementData", 
    "noteSchema",
    "associatedMedias",
    "title",
    "translatedTitle",
    "indexTitle",
    "type",
    "favType",
    "institutionCreation",
    "institutionSharing",
    "numberingUsed",
    "migrationSchema",
]

export interface BusinessResource {
    id?: string | null
    managementData?: ManagementDataResource | null
    noteSchema?: NoteSchemaResource | null
    associatedMedias?: AssociatedMediasResource | null
    title?: string | null
    translatedTitle?: TranslatedString | null
    indexTitle?: object | null
    type?: string | null
    favType?: string | null
    institutionCreation?: string | null
    institutionSharing?: string[] | null
    numberingUsed?: string | null
    migrationSchema?: MigrationSchemaResource | null
    /*@JsonIgnore
    private transient Iterable<Link> _links*/
    recordVersion?: number | null
}

export interface NoteSchemaResource {
    notes?: NoteResource[] | null
}

export interface NoteResource {
    typeOfNote?: TranslatedString | null
    note?: TranslatedString | null
    noteCode?: String | null
}

export interface MigrationSchemaResource {
    originalIdentifier?: string
    originalTable?: string
    originalBase?: string
}